module.exports = __webpack_public_path__ + "87efb96dbb647295043ad7915912bb52.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/account.jpg
 ** module id = 1546
 ** module chunks = 0
 **/